import { render, staticRenderFns } from "./productsDetailThree.vue?vue&type=template&id=7434e195&scoped=true&"
import script from "./productsDetailThree.vue?vue&type=script&lang=js&"
export * from "./productsDetailThree.vue?vue&type=script&lang=js&"
import style0 from "./productsDetailThree.vue?vue&type=style&index=0&id=7434e195&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7434e195",
  null
  
)

export default component.exports